import React from 'react';
import Heading from '../../components/heading';
import CreateClassificationForm from '../../components/districts/classifications/CreateClassificationForm';

const CreateClassification = props => {
    const { match } = props;

    
    return (
        <section>
            <Heading heading={match.params.id ? 'Ändra klassificering' : 'Ny klassificering' }/>
            <CreateClassificationForm />
        </section>
    );
};

export default CreateClassification;